<!--
  This dialog will be used to save custom location of caller on RideOrdering form.
-->
<template>
  <dialog-form
    :show-dialog="isShowDialog"
    :is-disabled="!customLocationOrder && !locationType"
    @open="dialogOpen"
    @cancel="hideDialog"
    @submit="saveLocation"
  >
    <template #title>
      Save Location Type
    </template>

    <el-radio-group v-model="locationType">
      <div class="row">
        <div class="col-6 pr-0 pb-10 mobile-pb-10">
          <el-radio
            id="homeAddress"
            label="home"
          >
            Home
          </el-radio>
        </div>

        <div class="col-6 pr-0 pb-10 mobile-pb-10">
          <el-radio
            id="customLocation3"
            label="customa"
          >
            Custom Location #3
          </el-radio>
        </div>

        <div class="col-6 pr-0 pb-10 mobile-pb-10">
          <el-radio
            id="customLocation4"
            label="customb"
          >
            Custom Location #4
          </el-radio>
        </div>

        <div class="col-6 pr-0 pb-10 mobile-pb-10">
          <el-radio
            id="customLocation5"
            label="customc"
          >
            Custom Location #5
          </el-radio>
        </div>
      </div>
    </el-radio-group>

    <div class="row">
      <div class="field-group col-sm-6">
        <dropdown-list v-model="customLocationOrder">
          <template #additional-options-prefix>
            <el-option
              :key="0"
              label="None Selected"
              :value="0"
              disabled
            >
              None Selected
            </el-option>
            <el-option
              v-for="(customLocation, index) in customAddressTypeList"
              :key="index + 1"
              :value="customLocation.order"
              :label="customLocation.label"
            >
              {{ customLocation.label }}
            </el-option>
          </template>
        </dropdown-list>
      </div>
    </div>

    <template #submit-button>
      Save Location
    </template>
  </dialog-form>
</template>

<script setup lang="ts">
import { computed, ref, watch } from 'vue';
import { customLocationTypeList } from '@/constants/address';

defineProps({
  isShowDialog: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['submit', 'cancel']);

const locationType = ref('');
const customLocationOrder = ref(0);

const customAddressTypeList = computed(() => customLocationTypeList.filter(({ type }) => type === 1));

const saveLocation = () => {
  let location: any;

  if (locationType.value) {
    location = {
      type: 'locationType',
      value: locationType.value,
    };
  } else {
    location = {
      type: 'locationOrder',
      value: customLocationOrder.value,
    };
  }

  emit('submit', location);
};

const dialogOpen = () => {
  locationType.value = '';
  customLocationOrder.value = 0;
};

const hideDialog = () => {
  emit('cancel');
};

// Unselect the customLocationOrder if homeAddress or location #3, #4 or #5 is chosen
watch(locationType, (value: string) => {
  if (value) {
    customLocationOrder.value = 0;
  }
});

// Unselect the locationType if customLocation 1*-8* is chosen
watch(customLocationOrder, (value: number) => {
  if (value) {
    locationType.value = '';
  }
});
</script>
